export function shouldOpenInContentWindow(event) {
  // Plain left-click only — allow modified clicks and middle-click for new tab / new window.
  return (
    event.type === "click" &&
    event.button === 0 &&
    !event.ctrlKey &&
    !event.metaKey &&
    !event.shiftKey &&
    !event.altKey
  )
}
